import React, { Fragment } from 'react';
import ToolBarMenu from './../../components/ToolBarMenu/index';
import Header from './../../components/Header/index';
import PageHeader from './../../components/PageHeader/index';
import Footer from './../../components/Footer/index';
import PageWrapper from './../../components/PageWrapper/index';
import { useBeneficiary } from './../../queries/beneficiary';
import './index.scss';
import { useParams } from 'react-router-dom';
import {getImagesWithAbsolutePath, myDomain} from '../../helpers/urlHelper';
import InfinitProgressBar from '../../components/InfiniteProgressBar';

const Beneficiary = () => {

    
    const{id} = useParams()
    
    const BeneficiaryInfo = useBeneficiary(id);
    if (BeneficiaryInfo.error) return <div>error!</div>
    if (BeneficiaryInfo.loading) return <InfinitProgressBar />
    console.log(BeneficiaryInfo.data);
    return (  
        <Fragment>
            {/* <ToolBarMenu/> */}
            <Header/>
            <PageHeader
                bgImg={BeneficiaryInfo.data.beneficiary[0].beneficiaryPageHeader.urls[0]}
                title={BeneficiaryInfo.data.beneficiary[0].displayText}
                content=''
            />
            <div style={{padding:"3rem 10%", lineHeight:"40px"}} className={`col-12  ${id === "foreignmarkets"? 'table-style' : null}`} dangerouslySetInnerHTML={{__html: getImagesWithAbsolutePath(BeneficiaryInfo.data.beneficiary[0].htmlBody.html, myDomain)}}/>
            <br/>
            <br/>
            <br/>
            <Footer/>
        </Fragment>
    );
}
 
export default Beneficiary;